#!/usr/bin/env node

const { sockets } = require('@runeya/common-socket-server');
const migrateStackMonitor  = require('../helpers/migrateStackMonitor');
const createDefaultFiles = require('../helpers/createDefaultFiles');
const plugins = require('../helpers/plugins');

process.title = 'runeya';
const args = require('../helpers/args');


require('dotenv').config();
(async () => {
  await migrateStackMonitor();
  await createDefaultFiles();
  await plugins.init();
  if(args['pull-env']) {
    await require('../models/stack').selectConf();
    const service = require('../models/stack').findService(args.s)
    if(!service) {
      console.error('Service', args.s, 'not found')
      process.exit(1)
    }
    const envs = await service.buildEnvs(args['e'])
    console.log(Object.keys(envs).reduce((agg, key) => (agg+=`\n${key}=${envs[key]}`), '').trim())
    process.exit(0)
  } else {
    console.log('Root path:', args.rootPath)
    require('./server')
      .launch()
        .catch((err) => {
          console.error(err)
          return err
        })
  }
})()

process.on('uncaughtException', (err) => {
  console.error('Uncaught exception:', err);
  sockets.emit('critical:error', err);
});

process.on('unhandledRejection', (reason, promise) => {
  console.error('Unhandled rejection:', reason);
  sockets.emit('critical:error', reason);
});
